<template>
  <div>
    <!-- <el-checkbox v-model="enable"></el-checkbox> -->
    <!-- {{ discount.length }}
    {{ discount }} -->
    <!-- {{ type }} -->
    <!-- {{ data }} -->
    <!-- discount:{{ discount }}
    <hr />
    type:{{ type }} -->

    <div>
      <van-radio-group v-model="type" @change="onChange">
        <van-row>
          <van-col span="6">
            <div class="label">預設</div>
            <van-radio name="">不使用</van-radio>
          </van-col>
          <van-col span="6">
            <div class="label">單件折扣</div>
            <van-radio
              v-for="r in columns.filter((r) => r.buyQty == 1)"
              :key="r.id"
              :name="r.id"
            >
              {{ getDCText(r) }}
            </van-radio>
          </van-col>
          <van-col span="6">
            <div class="label">同品項2件</div>
            <van-radio
              v-for="r in columns.filter((r) => r.buyQty == 2)"
              :key="r.id"
              :name="r.id"
            >
              {{ getDCText(r) }}
            </van-radio>
          </van-col>
          <van-col span="6">
            <div class="label">同品項3件</div>
            <van-radio
              v-for="r in columns.filter((r) => r.buyQty == 3)"
              :key="r.id"
              :name="r.id"
            >
              {{ getDCText(r) }}
            </van-radio>
          </van-col>
        </van-row>
      </van-radio-group>
    </div>
  </div>
</template>
<style scoped>
.van-radio {
  height: 3rem;
}
.label {
  background-color: #eee;
  margin-right: 1rem;
  padding-left: 1rem;
}
</style>
<script>
export default {
  props: {
    discount: Array,
  },
  mounted() {
    var dc = this.discount;
    console.log("Discount.monted", dc);
    if (dc.length > 0) {
      this.type = dc[0].id;
    }
  },
  data() {
    return {
      enable: false,
      type: "",
      columns: [
        {
          id: "010190",
          label: "",
          buyQty: 1,
          getQty: 1,
          rate: 90,
        },
        {
          id: "010180",
          label: "",
          buyQty: 1,
          getQty: 1,
          rate: 80,
        },
        {
          id: "010170",
          label: "",
          buyQty: 1,
          getQty: 1,
          rate: 70,
        },
        {
          id: "010160",
          label: "",
          buyQty: 1,
          getQty: 1,
          rate: 60,
        },
        {
          id: "010150",
          label: "",
          buyQty: 1,
          getQty: 1,
          rate: 50,
        },
        {
          id: "020100",
          label: "",
          buyQty: 2,
          getQty: 1,
          rate: 0,
        },
        {
          id: "020150",
          label: "",
          buyQty: 2,
          getQty: 1,
          rate: 50,
        },
        {
          id: "020260",
          label: "",
          buyQty: 2,
          getQty: 2,
          rate: 60,
        },
        {
          id: "020270",
          label: "",
          buyQty: 2,
          getQty: 2,
          rate: 70,
        },
        {
          id: "020275",
          label: "",
          buyQty: 2,
          getQty: 2,
          rate: 75,
        },
        {
          id: "030100",
          label: "",
          buyQty: 3,
          getQty: 1,
          rate: 0,
        },
        {
          id: "030370",
          label: "",
          buyQty: 3,
          getQty: 3,
          rate: 70,
        },
        {
          id: "030360",
          label: "",
          buyQty: 3,
          getQty: 3,
          rate: 60,
        },
        {
          id: "030350",
          label: "",
          buyQty: 3,
          getQty: 3,
          rate: 50,
        },
      ],
    };
  },
  methods: {
    getDCText(row) {
      var buyQty = Number(row.buyQty);
      var getQty = Number(row.getQty);
      var rate = Number(row.rate);

      if (buyQty == 1) {
        // var off = 100 - rate + "%off";
        return rate/10 + "折";
      }

      if (buyQty == getQty) {
        return buyQty + "件" + rate/10 + "折";
      }

      if (buyQty == 2) {
        if (rate == 0) {
          return "買1送1";
        }
        if (rate == 50) {
          return "第" + buyQty + "件半價";
        }
        return "第" + buyQty + "件" + rate/10 + "折";
      }

      if (buyQty == 3) {
        if (rate == 0) {
          return "買2送1";
        }

        if (rate == 5) {
          return "第" + buyQty + "件半價";
        }

        return "第" + buyQty + "件" + rate /10 +"折";
      }
    },
    onChange(id) {
      if (id == undefined) {
        return;
      }
      if (id == "") {
        return this.$emit("change", "");
      }
      var find = this.columns.find((r) => r.id == id);
      find.text = this.getDCText(find);
      this.$emit("change", find);
    },
  },
};
</script>
